import { useEffect, useState } from 'react';

/**
 * A live clock: returns the current `Date` and re-renders every `intervalMs`
 * (minute-level by default — mirrors StageSchedule's `liveNow` pattern).
 * Used to keep time-derived labels like the market-status chip fresh.
 */
export function useNow(intervalMs = 60_000): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
